import { render, staticRenderFns } from "./change_city.vue?vue&type=template&id=264e27ba&scoped=true"
import script from "./change_city.vue?vue&type=script&lang=js"
export * from "./change_city.vue?vue&type=script&lang=js"
import style0 from "./change_city.vue?vue&type=style&index=0&id=264e27ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264e27ba",
  null
  
)

export default component.exports